export const endpoint = "https://v8.js-dos.com";
export const authentificator = endpoint + "/auth/";
export const uploadsS3Bucket = "doszone-uploads";
export const uploadsS3Url = "https://storage.yandexcloud.net";
export const uploadNamspace = "dzapi";

export const apiEndpoint = "https://d5dn8hh4ivlobv6682ep.apigw.yandexcloud.net";
export const presignPut = apiEndpoint + "/presign-put";

export const xsollaSubscriptons = "https://subscriptions.xsolla.com​/api/user/v1/projects/184012/subscriptions";
export const xsollaPremiumId = "sumOxNVr";

export const brCdn = "https://br.cdn.dos.zone";

export const cancelSubscriptionPage = {
    en: "https://v8.js-dos.com/cancel-your-subscription/",
    ru: "https://v8.js-dos.com/ru/cancel-your-subscription/",
};

export const actualWsVersion = 2;
